import React from 'react';
import {Routes, Route} from 'react-router-dom';
import {ThemeProvider} from './contexts/ThemeContext';
import {LanguageProvider} from './contexts/LanguageContext';
import Layout from './components/Layout';
import MetronomeApp from './components/MetronomeApp';
import DocumentHead from './components/DocumentHead';
import Features from './pages/Features';
import HowToUse from './pages/HowToUse';
import About from './pages/About';
import NotFound from './pages/NotFound';
import './App.css';

function App() {
  return (
    <ThemeProvider>
      <LanguageProvider>
        <div className="min-h-screen bg-gray-50 dark:bg-gray-900 transition-colors duration-300">
          <DocumentHead />
          <Routes>
            <Route path="/" element={<Layout />}>
              <Route index element={<MetronomeApp />} />
              <Route path="features" element={<Features />} />
              <Route path="how-to-use" element={<HowToUse />} />
              <Route path="about" element={<About />} />
              <Route path="*" element={<NotFound />} />
            </Route>
          </Routes>
        </div>
      </LanguageProvider>
    </ThemeProvider>
  );
}

export default App;